export default __webpack_public_path__ + "static/media/photo_2022-05-15_11-48-56.a0c18e24.jpg";